module.exports = __webpack_public_path__ + "img/22.bc915b8c.jpg";